// @flow
import { handleActions } from 'redux-actions';
import { storeDistributionStatus } from './distributionActions';
import AsyncValues, { type AsyncValueType } from 'lib/async-value';

export type DistributionState = AsyncValueType<boolean>;

export default handleActions(
  {
    [storeDistributionStatus.toString()]: (
      state: DistributionState,
      action: *
    ) => {
      return action.payload;
    },
  },
  AsyncValues.Pending
);



// WEBPACK FOOTER //
// ./src/containers/client/distributionReducer.js